import { useRef, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetIndividualVolumesQuery } from '../store/services';
import VolumesList from '../../partial/volumes/list';
import { RiskScoreClientTypeEnum } from '../../types';

import cn from '../individual-clients-risk.module.css';

const IndividualVolumes = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const {
    individualClientsRisk: {
      volumes: {
        list: { values },
      },
    },
  } = useAppSelector((state) => state);

  const [getIndividualVolumes, { isLoading, isFetching }] =
    useLazyGetIndividualVolumesQuery();
  let content;

  useEffect(() => {
    let title = 'Individual Volumes risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  if (isLoading) {
    content = (
      <div className={cn.volumesLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <VolumesList
        getList={getIndividualVolumes}
        isLoading={isLoading}
        isFetching={isFetching}
        values={values}
        type={RiskScoreClientTypeEnum.INDIVIDUAL}
      />
    );
  }

  return (
    <div className={cn.volumesBottom}>
      <div className={cn.volumesTableWrapper} ref={scrollRef}>
        {content}
      </div>
      <Outlet />
    </div>
  );
};

export default IndividualVolumes;
